import planejamentoDefinicaoPassos from '../../../produto/spa/planejamento-contrato/form/planejamentoDefinicaoPassos';

export default planejamentoDefinicaoPassos;
